<template>
  <v-expand-transition class='w-expandable-y'>
    <div
      v-show='value'
      class='w-expandable-y__content-wrapper'
    >
      <slot />
    </div>
  </v-expand-transition>
</template>

<script>
import { useTimerManager } from '@/composables/timer-manager';

/**
 * @component WorkExpandableY
 * @description Vertical expand animation with `v-expand-transition`.
 * Emits optional transition events when showing and hiding.
 *
 * @prop {Boolean} value - Visibility (v-model). (Required)
 * @prop {Boolean} [withoutTransitionEvents=false] - Disable transition events.
 *
 * @emits {void} transition:started - Emitted when the animation starts.
 * @emits {void} transition:finished - Emitted when the animation completes.
 *
 * @slot default - Content that is expanded/collapsed.
 */
export default {
  name: 'WorkExpandableY',
  props: {
    value: { type: Boolean, required: true },
    withoutTransitionEvents: { type: Boolean, default: false },
  },
  setup() {
    const { registerTimeout } = useTimerManager();
    return {
      registerTimeout,
    };
  },
  watch: {
    value() {
      if (this.withoutTransitionEvents === true) { return }

      this.$emit('transisiton:started');
      this.registerTimeout(() => this.$emit('transisiton:finished'), 300);
    }
  }
};
</script>
